import type { FC, ReactNode } from "react";
import { Card } from "@ui/Card";

interface SummaryCardProps {
  title: string;
  children: ReactNode;
  dataTest?: string;
}

export const SummaryCard: FC<SummaryCardProps> = ({ children, title, dataTest }) => {
  return (
    <Card
      className="vtac:border-transparent gap-4 px-4 py-[18px] md:gap-10 md:px-12 md:py-10"
      data-test={dataTest}
    >
      <h3
        className="text-xl font-bold md:text-2xl lg:text-[34px]"
        data-test={dataTest ? `${dataTest}-title` : undefined}
      >
        {title}
      </h3>
      {children}
    </Card>
  );
};
